export const CLICKED_TOOLTIP_EVENT = 'Clicked tooltip';
export const HOVER_TOOLTIP_EVENT = 'Hover tooltip';
